import type { DevModeSnippetExample } from '@cli-types/next-adapter/generators.js'
import { createExample } from './create-example.js'
import { isScalarIdentifierPayload } from './is-scalar-identifier-payload.js'
export function createPayloadExample(value: unknown): DevModeSnippetExample | undefined {
  if (isScalarIdentifierPayload(value)) {
    return undefined
  }

  return createExample('Payload', value)
}
